import React from 'react'

//Functions.
  //Slices.
  import { useSelector } from 'react-redux';
  import { allUpcomingChallenges } from '../../../slices/challengesSlice';

//Components.
import ChallengeAnnouncementsComponent from '../../../components/challenges/challenge-announcements/ChallengeAnnouncementsComponent';

import "./ChallengeAnnouncementsPage.styles.css";


const ChallengeAnnouncementsPage = () => {
   const allChallengeAnnouncements = useSelector(allUpcomingChallenges);

   if (Object.values(allChallengeAnnouncements).length > 0) {
      return <ChallengeAnnouncementsComponent />
   }
   else {
      return (
         <div>
            <h1><em className='text-danger'>SORRY...</em> there are no challenge announcements as of right now.</h1>
         </div>
      )
   }
   
}

export default ChallengeAnnouncementsPage